"use strict";
exports.__esModule = true;
exports.PlatformAssetCatalogBuilder = void 0;
var core_designer_domain_1 = require("@jewelutions/core-designer-domain");
var PlatformAssetCatalogBuilder = /** @class */ (function () {
    function PlatformAssetCatalogBuilder(initialAssetCatalog) {
        this.catalog = initialAssetCatalog;
        return this;
    }
    PlatformAssetCatalogBuilder.initiateWithEmptyAssets = function () {
        return new PlatformAssetCatalogBuilder({
            pieces: [],
            accessories: []
        });
    };
    PlatformAssetCatalogBuilder.initiateWithPlatformAssetCatalog = function (initialAssetCatalog) {
        return new PlatformAssetCatalogBuilder(initialAssetCatalog);
    };
    PlatformAssetCatalogBuilder.prototype.build = function () {
        return this.catalog;
    };
    PlatformAssetCatalogBuilder.prototype.addPieceAsset = function (newPieceReference) {
        this.catalog.pieces = this.catalog.pieces.filter(function (existingPieceReference) { return !core_designer_domain_1.PieceReference.identical(existingPieceReference, newPieceReference); });
        this.catalog.pieces.push(newPieceReference);
        return this;
    };
    PlatformAssetCatalogBuilder.prototype.clearPieceAssets = function () {
        this.catalog.pieces = [];
        return this;
    };
    PlatformAssetCatalogBuilder.prototype.addAccessoryAsset = function (newAccessoryReference) {
        this.catalog.accessories = this.catalog.accessories.filter(function (existingAccessoryReference) { return !core_designer_domain_1.AccessoryReference.identical(existingAccessoryReference, newAccessoryReference); });
        this.catalog.accessories.push(newAccessoryReference);
        return this;
    };
    PlatformAssetCatalogBuilder.prototype.clearAccessoryAssets = function () {
        this.catalog.accessories = [];
        return this;
    };
    return PlatformAssetCatalogBuilder;
}());
exports.PlatformAssetCatalogBuilder = PlatformAssetCatalogBuilder;
